// src/config/api.js

// Use environment variable in production, fallback to localhost in development
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const API_ENDPOINTS = {
  // Auth
  login: `${API_BASE_URL}/api/auth/login`,
  register: `${API_BASE_URL}/api/auth/register`,
  
  // Events
  events: `${API_BASE_URL}/api/events`,
  eventById: (id) => `${API_BASE_URL}/api/events/${id}`,
  eventImages: (id) => `${API_BASE_URL}/api/events/${id}/images`,
  deleteEventImage: (eventId, imageId) => `${API_BASE_URL}/api/events/${eventId}/images/${imageId}`,
  
  // Contact
  contact: `${API_BASE_URL}/api/contact`,
  
  // Health check
  health: `${API_BASE_URL}/api/health`,
};

export default API_BASE_URL;